"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = observableToPromise;

function observableToPromise(observable) {
  return new Promise(function (resolve, reject) {
    var subscription = observable.subscribe(function (sessionId) {
      resolve(sessionId); // HACK: Sometimes, the call complete asynchronously and we cannot unsubscribe
      //       Need to wait some short time here to make sure the subscription variable has setup

      setTimeout(function () {
        return subscription.unsubscribe();
      }, 0);
    }, function (error) {
      reject(error);
      setTimeout(function () {
        return subscription.unsubscribe();
      }, 0);
    });
  });
}